export const LANGUAGES = ["Python", "Html", "C", "JavaScript", "CSS", "TypeScript"];
